const colors = {
  darkBlue: '#000850',
  white: '#FFFFFF',
  greyLightBlue: '#F8F9FE',
  grey: '#D4D7DB',
  requirementGrey: '#A7A7A7',
};

export default colors;
